import { render } from "./DataPaginator.vue?vue&type=template&id=f1159dcc"
import script from "./DataPaginator.vue?vue&type=script&lang=js"
export * from "./DataPaginator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__